import environment from '../../../common/environment';
import { ariaLabelWithNewTab } from '../../../common/utils/a11y-util';
import { OrderHistory as IOrderHistory, UserOrderDetails } from '../../order-history/order-history.interface';
import { html, TemplateResult } from 'lit';

/**
 * My bookshelf CTA for my digital products and order history sections.
 *
 * @param order
 * @param userOrderDetails
 * @param analyticsCallback
 */
export function getMyBookshelfLaunchCta(
  order: IOrderHistory,
  userOrderDetails: UserOrderDetails,
  analyticsCallback: Function
): TemplateResult {
  const btnName = 'My Bookshelf';
  const hrefGenerated = environment().myBookShelfUrl;
  return html`
    <a
      class="btn btn-outline-primary w-100 w-lg-75"
      aria-label="${ariaLabelWithNewTab('My Bookshelf')}"
      @click=${() => analyticsCallback('go-to-bookshelf', btnName, order, userOrderDetails, hrefGenerated)}
      href=${hrefGenerated}
      target="_blank"
      data-automation-id="btn-bookshelf-${order.webOrderNo}-${userOrderDetails.isbn10}"
    >
      ${btnName}&nbsp;
      <uxt-icon icon="box-arrow-up-right"></uxt-icon>
    </a>
  `;
}

export const REDEEM_BTN_TEXT = 'Have ebook code? Redeem now';